const formatMoney = (money: number, decimals = 0) => {
  if (!money) return '0';

  if (decimals > 0) {
    const hasDecimalPart = money % 1 !== 0;

    if (hasDecimalPart) {
      const formatted = money.toFixed(decimals);
      const parts = formatted.toString().split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return `${parts.join('.')}`;
    }
  }

  const formatted = money.toFixed(0);
  return formatted.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const formattedMoneyToNumber = (money: string) => {
  return Number(money.replace(/,/g, ''));
};

export default formatMoney;
export { formatMoney, formattedMoneyToNumber };
